import {
	CrownOutlined,
	ExperimentOutlined,
	TeamOutlined,
	UserOutlined,
} from '@ant-design/icons';
import { Card, Col, Row, Statistic } from 'antd';
import { useTranslation } from 'react-i18next';

interface PlatformMetricsProps {
	totalUsers: number;
	totalPets: number;
	aiScansToday: number;
	activeSubscriptions: number;
	loading?: boolean;
}

const PlatformMetrics = ({
	totalUsers,
	totalPets,
	aiScansToday,
	activeSubscriptions,
	loading = false,
}: PlatformMetricsProps) => {
	const { t } = useTranslation('components');

	const metrics = [
		{
			title: t('dashboard.metrics.petOwners'),
			value: totalUsers,
			icon: <UserOutlined className='text-blue-500' />,
		},
		{
			title: t('dashboard.metrics.totalPets'),
			value: totalPets,
			icon: <TeamOutlined className='text-green-500' />,
		},
		{
			title: t('dashboard.metrics.aiScansToday'),
			value: aiScansToday,
			icon: <ExperimentOutlined className='text-purple-500' />,
		},
		{
			title: t('dashboard.metrics.proSubscribers'),
			value: activeSubscriptions,
			icon: <CrownOutlined className='text-amber-500' />,
		},
	];

	return (
		<Row gutter={[16, 16]}>
			{metrics.map((metric) => (
				<Col xs={12} sm={6} key={metric.title}>
					<Card
						className='border border-slate-100 shadow-sm rounded-lg hover:shadow-md transition-shadow'
						styles={{ body: { padding: '16px' } }}
						loading={loading}
					>
						<div className='flex items-center justify-between'>
							<div>
								<div className='text-xs text-slate-500 mb-1'>{metric.title}</div>
								<Statistic
									value={metric.value}
									valueStyle={{ fontSize: '24px', fontWeight: 'bold', color: '#1e293b' }}
								/>
							</div>
							<div className='text-2xl'>{metric.icon}</div>
						</div>
					</Card>
				</Col>
			))}
		</Row>
	);
};

export { PlatformMetrics };
export default PlatformMetrics;
